// extracted by mini-css-extract-plugin
export default {"branding":"sZR_W","powered-by":"epMJw","icon":"umppz","powered-by--light":"j6t1R","powered-by--small":"vmaSZ"};